/**
 * Swallow noise from browser extensions / preview-environment messaging that
 * would otherwise trigger React's dev error overlay. These errors are NOT
 * from our application code — they come from Chrome extensions (LastPass,
 * Bitwarden, MetaMask, Honey, Grammarly, etc.) whose content scripts
 * occasionally fire `tabs.outgoing.message`, `Extension context invalidated`,
 * etc. against the page.
 *
 * This filter must be imported BEFORE React mounts so it registers before
 * react-error-overlay subscribes to window.error.
 */

const NOISE_PATTERNS = [
  "tabs.outgoing.message",
  "No Listener:",
  "Extension context invalidated",
  "ResizeObserver loop limit exceeded",
  "ResizeObserver loop completed",
  "chrome-extension://",
  "moz-extension://",
  "safari-web-extension://",
  // Long-poll / dev-server reconnection noise from preview env
  "WebSocket connection",
  "websocket connection",
  "the message port closed before",
  "Could not establish connection",
];

function isNoise(text) {
  if (!text) return false;
  const t = String(text);
  return NOISE_PATTERNS.some((p) => t.includes(p));
}

function install() {
  if (typeof window === "undefined") return;
  if (window.__govbidiq_error_filter_installed__) return;
  window.__govbidiq_error_filter_installed__ = true;

  // Synchronous errors
  window.addEventListener(
    "error",
    (event) => {
      const msg = event?.message || event?.error?.message;
      const src = event?.filename || event?.error?.stack;
      if (isNoise(msg) || isNoise(src)) {
        event.stopImmediatePropagation();
        event.preventDefault();
        return false;
      }
      return undefined;
    },
    true // capture phase — run before react-error-overlay
  );

  // Promise rejections
  window.addEventListener(
    "unhandledrejection",
    (event) => {
      const reason = event?.reason;
      const msg =
        typeof reason === "string"
          ? reason
          : reason?.message || reason?.toString?.();
      if (isNoise(msg)) {
        event.stopImmediatePropagation();
        event.preventDefault();
        return false;
      }
      return undefined;
    },
    true
  );
}

install();

export {};
